module.exports = __webpack_public_path__ + "assets/img/btn-info-50a2c6a4.png";